/*
 * @Author: Merlin
 * @Date: 2024-11-06 14:30:55
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-09 17:22:49
 * @Description: 
 */
// ↓ 官方说明： http://www.quasarchs.com/quasar-plugins/notify 
import { Notify  } from 'quasar'; 


// ↓ 直接调用官方原版方法，便于四处调用，主要是省得在各处的顶部书写 import {Notify}
export const showNotify = (options) => {
    Notify.create(options);
}

// ↓ 用于弹出请求报错消息，等故障消息 
export const showNegativeNotify = (
    vMsg,
) => {
    const {t: $tFn} = useNuxtApp().$i18n;
    const options = {
        message: '', // 弹出后显示在消息的第 1️⃣ 行；之前旧的默认值 $tFn('commonInfo.tips') 
        caption: '', // 位于第 2️⃣ 行，以下方为此赋值 
        // ↓ 可选值： positive, negative, warning, info 
        type: 'negative', // 红色弹出消息，表示执行失败 
        position: 'center', // 默认在中心弹出（遵从指示从顶部移动到中间的）  
        // icon: '', // 传入空字符表示不需要图标；续：按新设计方法，需要图标、不传此值将应用默认图标
        // timeout: 1 * 1_000, // 驻留时长 ms
        classes: '', // ← 添加类名便于进行样式干预 
        actions: [{
            label: $tFn('commonInfo.close'),
            // color: 'white', // 已经在样式文件中控制颜色 
            handler: () => console.log('Closed'),
        }],
    };
    if (typeof vMsg === 'string'){
        options.message = vMsg;
    }else if (vMsg && typeof vMsg === 'object'){
        if (vMsg.i18n){
            // 支持带参数的国际化文本
            vMsg.message = vMsg.options ? $tFn(vMsg.i18n, vMsg.options) : $tFn(vMsg.i18n); 
        }
        // ↓ 用于弹出后端直接返回的报错对象，弹出其中的 error 值 
        vMsg.message ||= vMsg.error; 
        Object.assign(options, vMsg);
    }else{
        options.message = $tFn('commonInfo.error');
        console.error('提示内容缺失'); 
    }
    // ↓ 重要操作，全局样式将为 type_ 元素有样式覆盖 
    options.classes += ` type_${options.type}`;
    // ↓ 返回值是一个方法 
    const fn = Notify.create(options as any);
    // console.log('Notify.create()', fn); 
    return fn;
}

/**
 * 弹出提示： 上局游戏已经加载 
 */
export const showLastRoundLoadedInfo = ()=>{
    showNegativeNotify({
        type: 'info',
        position: 'top',
        i18n: 'commonInfo.hasLoadedLastRound', 
        progress: true,
        timeout: 1_800,
        actions: [],
    });
}

/**
 * 金额变动触及边缘时的提示 
 * @param toast 
 * @returns 
 */
export const showToastIfNeeded = async (toast)=>{
    if (!toast) return;
    showNegativeNotify({
        i18n: toast,
        position: 'top', // 在顶部弹出，防止侵入用户操作  
        type: 'warning',
        timeout: 1.5 * 1_000, // 驻留时长 ms
    });
}


